import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './LoadingOverlay.css';

const LoadingOverlay = ({ isLoading, onExitComplete }) => {
  const { t } = useTranslation();
  const [prevIsLoading, setPrevIsLoading] = useState(isLoading);
  const [shouldRender, setShouldRender] = useState(isLoading);
  const [isExiting, setIsExiting] = useState(false);
  const exitFiredRef = useRef(false);
  const containerRef = useRef(null);

  if (isLoading !== prevIsLoading) {
    setPrevIsLoading(isLoading);
    if (isLoading) {
      setShouldRender(true);
      setIsExiting(false);
      exitFiredRef.current = false;
    } else {
      setIsExiting(true);
    }
  }

  const handleTransitionEnd = (e) => {
    // Only react to the container's own transition, not bubbled child events
    if (e.target !== containerRef.current) return;
    // Only fire once (transitions fire per-property: opacity + visibility)
    if (exitFiredRef.current) return;
    if (isExiting) {
      exitFiredRef.current = true;
      setShouldRender(false);
      onExitComplete?.();
    }
  };

  if (!shouldRender) return null;

  return (
    <div
      ref={containerRef}
      className={`loading-overlay-container ${isExiting ? 'exiting' : ''}`}
      onTransitionEnd={handleTransitionEnd}
    >
      <div className="loading-content">
        <img
          src="/assets/logo/symbol-logo/agapae-symbol-only-white.svg"
          alt={t("loading.logoAlt")}
          className="loading-logo"
        />
        <div className="loading-text-wrapper">
          <h2 className="heading-38 white-text">
            {t("loading.text")}
          </h2>
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlay;
